import React from 'react';

const ErrorMessage = ({ message }) => {
  return (
    <div className="text-center text-red-600 p-4">
      Error: {message}
    </div>
  );
};

export default ErrorMessage;
